import { ConvprevService } from "../../services/models/convprev";
const moduleConvPrev = {
	namespaced: true,
	state: {
		convPrevs: [],
		loading: false,
	},
	getters: {
		getConvPrevs(state) {
			return state.convPrevs;
		},
		getLoading(state) {
			return state.loading;
		}
	},
	mutations: {
		loadConvPrevs(state, convPrevs) {
			state.convPrevs = convPrevs;
		}
	},
	actions: {
		async loadConvPrevs({ commit, state }) {
			state.loading = true;
			let convPrevs = await ConvprevService.getAll();
			commit("loadConvPrevs", convPrevs);
			state.loading = false;
		}
	}
}

export default moduleConvPrev;